// `credits.json`, generated by `pnpm assets:build` (scripts/assets/lib/credits.ts owns the format).

export interface CreditsEntry {
  readonly title: string
  readonly authors: readonly string[]
  readonly license: { readonly id: string; readonly name: string; readonly url: string }
  readonly source: { readonly name: string; readonly url: string }
  readonly creditLine?: string
  readonly changes?: string
}

interface CreditsGroup {
  /** Shown as `credits.group.<id>`. */
  readonly id: string
  readonly entries: readonly CreditsEntry[]
}

export interface Credits {
  readonly groups: readonly CreditsGroup[]
}

export async function loadCredits(signal: AbortSignal): Promise<Credits> {
  const response = await fetch(`${import.meta.env.BASE_URL}assets/credits.json`, { signal })
  if (!response.ok) throw new Error(`HTTP ${String(response.status)} for credits.json`)
  const credits = (await response.json()) as Partial<Credits>
  if (!Array.isArray(credits.groups)) throw new Error('credits.json has no groups')
  return credits as Credits
}
